__turbopack_context__.v({
  "clearDecklistInput": "find-my-combos-module-scss-module__rXTMwW__clearDecklistInput",
  "commanderInput": "find-my-combos-module-scss-module__rXTMwW__commanderInput",
  "decklistCardCount": "find-my-combos-module-scss-module__rXTMwW__decklistCardCount",
  "decklistHint": "find-my-combos-module-scss-module__rXTMwW__decklistHint",
  "decklistInput": "find-my-combos-module-scss-module__rXTMwW__decklistInput",
  "exportCombosInput": "find-my-combos-module-scss-module__rXTMwW__exportCombosInput",
  "findMyCombosContainer": "find-my-combos-module-scss-module__rXTMwW__findMyCombosContainer",
  "or": "find-my-combos-module-scss-module__rXTMwW__or",
});
